export enum Step {
  SELECT_SOURCES = 0,
  REVIEW_PLAN = 1,
  RESULTS = 2
}

export const stepKey = (step: Step): string => {
  switch (step) {
    case Step.SELECT_SOURCES:
      return "select-sources";
    case Step.REVIEW_PLAN:
      return "review-plan";
    case Step.RESULTS:
      return "results";
  }
};
